export const UPLOAD = 'UPLOAD' as const;
export const UPLOAD_FAILED = 'UPLOAD_FAILED' as const;
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS' as const;

export const DROP_REJECTED = 'DROP_REJECTED' as const;
export const UPLOADER_RESET = 'UPLOADER_RESET' as const;
